<template>
  <div class="row variant-section">
    <!--<div v-if="getScreenWidth > 991">-->
    <variant-template
      v-for="(variantCategories, value, index) in variants"
      :variantCategories="variantCategories"
      :value="value"
      :index="index"
      :key="index"
      v-show="getSelectedVariantData(variantCategories)"
      @variantSwitching="variantSwitch($event)"
    />

    <!--</div>-->
    <!--<div class="d-block d-lg-none col-12">-->
    <!--<div class="mobile-variant-wrapper">-->
    <!--<div-->
    <!--class="btn-group w-100"-->
    <!--role="group"-->
    <!--aria-label="Basic example"-->
    <!--&gt;-->
    <!--<button-->
    <!--v-for="(variantCategories, value, index) in variants"-->
    <!--:key="index"-->
    <!--type="button"-->
    <!--class="btn btn-secondary mobile-variant-button"-->
    <!--:style="'width: 33.3333%;'"-->
    <!--@click="openModal"-->
    <!--:data-test="'variantsListingButton'+index"-->
    <!--&gt;-->
    <!--&lt;!&ndash; Limit to 3 &ndash;&gt;-->
    <!--&lt;!&ndash; width for 1 100%, 2 - 50%, 3 - 33.3333% &ndash;&gt;-->
    <!--<span-->
    <!--class="fw"-->
    <!--v-for="(variant,key,index) in variantCategories"-->
    <!--:key="index"-->
    <!--:data-test="'variantsListingCategories'+index"-->
    <!--&gt;-->
    <!--{{variantSelectedClass(variant)}}-->
    <!--</span>-->
    <!--<span :data-test="'variantsListingValue'+index">{{value}} ({{3}})</span>-->
    <!--</button>-->
    <!--</div>-->
    <!--</div>-->
    <!--&lt;!&ndash; Modal &ndash;&gt;-->
    <!--<div-->
    <!--id="mobilevariantmodal"-->
    <!--class="mobile-variant-modal"-->
    <!--&gt;-->
    <!--<div class="wp_FilterHeader">-->
    <!--<div class="row">-->
    <!--<div class="col-6 wp_alignItems">-->
    <!--<span-->
    <!--class="wp_filtersBackarrow"-->
    <!--@click.prevent="backButtonAction"-->
    <!--data-test="variantsListingBackButtonSpan"-->
    <!--&gt;-->
    <!--<i class="fas fa-chevron-left"-->
    <!--data-test="variantsListingBackButtonIcon"></i>-->
    <!--</span>-->
    <!--<h5 data-test="variantsListingHeading">-->
    <!--Variants-->
    <!--</h5>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="p-3">-->
    <!--<variant-template-->
    <!--v-for="(variantCategories, value, index) in variants"-->
    <!--:variantCategories="variantCategories"-->
    <!--:value="value"-->
    <!--:index="index"-->
    <!--:key="index"-->
    <!--@variantSwitching="variantSwitch($event)"-->
    <!--/>-->
    <!--</div>-->
    <!--<div style="position: fixed;-->
    <!--bottom: 0;-->
    <!--width: 100%;-->
    <!--padding: 1em;">-->
    <!--<button-->
    <!--style="background: #2874f0;-->
    <!--padding: .7em;-->
    <!--width: 100%;-->
    <!--display: block;-->
    <!--text-align: center;-->
    <!--color: #fff;-->
    <!--font-size: 1.2em;"-->
    <!--@click.prevent="backButtonAction"-->
    <!--data-test="variantsListingApplyButton"-->
    <!--&gt;-->
    <!--Apply-->
    <!--</button>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
/* eslint-disable no-sequences */
import { mapActions, mapGetters } from 'vuex'
import VariantTemplate from './widgets/VariantTemplate'

export default {
	name: 'variants-listing',
	components: {
		VariantTemplate
	},
	computed: {
		...mapGetters('siteData', ['getScreenWidth']),
		...mapGetters('productselected', ['getSelectedVariant']),
		variants () {
			if (this.product && this.product.variants) {
				let result = []

				this.product.variants.forEach(variants => {
					for (const vari in variants.variant) {
						result.push({
							group_id: variants.group_id,
							product_id: variants.product_id,
							value: variants.variant[vari],
							key: vari
						})
					}
				})
				result = result.reduce(
					(h, obj) =>
						Object.assign(h, { [obj.key]: (h[obj.key] || []).concat(obj) }),
					{}
				)

				const groupBy = (arr, k) =>
					arr.reduce((r, c) => ((r[c[k]] = [...(r[c[k]] || []), c]), r), {})
				const resultArray = result
				for (const index in result) {
					resultArray[index] = groupBy(result[index], 'value')
				}

				return result
			}
			return ''
		}
	},
	methods: {
		...mapActions('productselected', ['setSelectedVariantData']),
		variantSwitch (productId) {
			let productCategoryId = ''
			if (this.$route.query && this.$route.query.productCategoryId) {
				productCategoryId = this.$route.query.productCategoryId
			}
			this.setSelectedVariantData(productId)
			this.$router.push({
				name: 'ProductDetails',
				path: '/product_description',
				query: {
					productId,
					productName: productId,
					productCategoryId
				}
			})
			this.$forceUpdate()
		},
		getSelectedVariantData (variantCategories) {
			const varientArray = []
			for (let [key, value] of Object.entries(variantCategories)) {
				varientArray.push({
					name: key,
					product_id: value[0].product_id
				})
			}
			let selectedVariantData = []
			if (varientArray.length > 0) {
				selectedVariantData = varientArray.filter(variant => {
					return this.getSelectedVariant === variant.product_id
				})
			}
			return selectedVariantData.length > 0
		},
		variantCheck () {
			if (this.getSelectedVariant !== this.$route.query.productId) {
				this.setSelectedVariantData(this.$route.query.productId)
			}
		},
		variantSelectedClass (variant) {
			let products = []
			if (variant && variant[0] && variant[0].product_id) {
				products = variant.findIndex(
					varia => this.getSelectedVariant === varia.product_id
				)
			}
			if (products > -1) {
				return variant[0].value
			}
		},
		openModal () {
			document.getElementById('mobilevariantmodal').classList.add('show')
		},
		backButtonAction () {
			document.getElementById('mobilevariantmodal').classList.remove('show')
			// if (this.filterCheckbox === true) {
			//   const contentId = document.getElementById('filterSlidingDivMobile');
			//   contentId.style.display = 'none';
			// } else {
			//   this.closeFilterPopUp();
			// }
			// this.filterCheckbox = false;
		}
	},
	mounted () {
		this.variantCheck()
	},
	props: {
		product: {}
	},
	watch: {
		$route () {
			this.variantCheck()
		}
	}
}
</script>

<style scoped>
</style>
